.filter-group {
    margin-right: 10px;
}

.template-count {
    letter-spacing: 0.5px;
    color: var(--grey-lt);
}
